import type {ReactAction} from '@netx/core/bootstrap';
import {faTrashAlt} from '@fortawesome/pro-solid-svg-icons';
import {canDeleteSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionDeleteIcon = faTrashAlt;

/**
 * Delete saved cart
 * @param params
 * @returns Action
 */
export const cartSavedActionDelete = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-delete',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.DELETE, savedCart),
	enableTest: () => canDeleteSavedCart(savedCart),
	icon: cartSavedActionDeleteIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.DELETE;
	},
	...params,
});

export default cartSavedActionDelete;
